import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWriting: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="writing, sketching, drawing"><path d="M18.25 2.75L11.75 9.25V12.25H14.75L21.25 5.75L18.25 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.25 12.25H5.75C4.64543 12.25 3.75 13.1454 3.75 14.25C3.75 15.3546 4.64543 16.25 5.75 16.25H16.25C17.3546 16.25 18.25 17.1454 18.25 18.25C18.25 19.3546 17.3546 20.25 16.25 20.25H11.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconWriting;
